import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

/**
 * Initialiserer Sentry for frontend. No-op hvis VITE_SENTRY_DSN ikke er satt
 * (lokal dev og preview uten Sentry-integration).
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA?.trim() || undefined,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    sendDefaultPii: false,
    beforeSend(event) {
      // Ikke send health-check støy
      if (event.request?.url?.includes("/api/health")) return null;

      // Filter benign DOM errors caused by browser extensions, Google Translate,
      // ad blockers etc. modifying DOM outside React's control. These errors
      // don't affect functionality and are not actionable.
      const message = event.exception?.values?.[0]?.value || "";
      if (
        message.includes("removeChild") ||
        message.includes("insertBefore") ||
        message.includes("appendChild")
      ) {
        const isNotFoundError = event.exception?.values?.[0]?.type === "NotFoundError";
        const isDOMException = event.exception?.values?.[0]?.type === "DOMException";
        if (isNotFoundError || isDOMException) {
          return null;
        }
      }

      return event;
    },
  });
}
